// 各种类型订单的数目
export default {
  setOrderNumber(state, orderNumbers) {
    state.orderNumbers = orderNumbers
  }
}
